import { render } from "./GeneralInfo.vue?vue&type=template&id=b425052e&scoped=true"
import script from "./GeneralInfo.vue?vue&type=script&lang=js"
export * from "./GeneralInfo.vue?vue&type=script&lang=js"

import "./GeneralInfo.vue?vue&type=style&index=0&id=b425052e&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b425052e"]])

export default __exports__